import React from 'react'
import {List as MUIList,ListItem, ListItemAvatar, ListItemText,Avatar,ListItemSecondaryAction,IconButton, Slide} from "@material-ui/core";
import { Delete, MoneyOff } from '@material-ui/icons';
import useStyles from './styles'
import { useContext } from 'react';
import {ExpenseTrackerContext} from '../../../context/context';

const List = () => {
  const {deleteTransaction,transactions} = useContext(ExpenseTrackerContext);
  // console.log(globalState);
//   const transactions = [
//     {id:1,type:'Income',category:'Salary', amount: 50, date: 'Thu Jan 26 2023'},
//     {id:2,type:'Expense',category:'Pets', amount: 50, date: 'Wed Jan 26 2023'},
//     {id:3,type:'Income',category:'Business', amount: 150, date: 'Fri Jan 26 2023'},
// ];
  const classes = useStyles();
  return (
    <MUIList dense = {false} className={classes.list}>
    {
      transactions.map((transaction)=>{
        return (
          <Slide direction='down' in mountOnEnter unmountOnExit key={transaction.id}>
            <ListItem>
              <ListItemAvatar>
                <Avatar className={transaction.type === 'Expense' ?classes.avatarExpense:classes.avatarIncome}>
                  <MoneyOff/>
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={transaction.category} secondary={`$${transaction.amount} - ${transaction.date}`}/>
              <ListItemSecondaryAction>
                <IconButton edge='end' aria-label='delete' onClick={()=> deleteTransaction(transaction.id)}>
                  <Delete/>
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </Slide>
        )
      })
    }
    </MUIList>
  )
}

export default List
